import { convertDtmForClimate } from '../generators/generate-preview-schedule-data'

const MS_PER_DAY = 24 * 60 * 60 * 1000

function addDays(date, days) {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

function addWeeks(date, weeks) {
  return addDays(date, weeks * 7)
}

/**
 * Computes frost risk for a single crop template using archetype defaults.
 * Mirrors useHarvestFrostWarning but works per-template without a generated schedule.
 * Returns { severity: 'error' | 'warning' } or null.
 */
export const calcTemplateWarning = (template, archetype, frostDates, collectionTypes, farmClimate) => {
  if (!template || !archetype) return null
  if (template.lifecycle_code === 'perennial') return null
  if (!frostDates?.ffd || !frostDates?.lfd) return null

  const ffd = new Date(frostDates.ffd)
  const lfd = new Date(frostDates.lfd)

  const plantingDate = addWeeks(lfd, archetype.indoor_sow_offset ?? 0)
  const transplantDate = addWeeks(lfd, archetype.outdoor_move_offset ?? 0)
  const dtmStart = archetype.dtm_starts_at_transplant ? transplantDate : plantingDate
  const rawDtm = template.dtm ?? archetype.dtm ?? 60
  const collection = collectionTypes?.find(c => c.code === template.collection_code)
  const gddBase = template.gdd_base ?? archetype.gdd_base ?? 10
  const dtm = convertDtmForClimate({ dtm: rawDtm, gddBase, collection, farmClimate })
  const harvestStart = addDays(dtmStart, dtm)

  const growthType = template.growth_code ?? 'determinate'

  if (harvestStart > ffd) return { severity: 'error', message: 'Harvest window trails the fall first frost, maturity at risk!' }

  // For determinate: generatePhases caps matureDays at daysUntilFrost, so matureEnd ≤ ffd always —
  // the harvest-window overlap warning can never fire without the error above firing first.
  // For indeterminate: mature phase extends to frost; warn if that window is < 2 weeks.
  if (growthType === 'indeterminate') {
    const daysToFrost = (ffd - harvestStart) / MS_PER_DAY
    if (daysToFrost < 14) return { severity: 'warning', message: 'Indeterminate harvest window is less than 2 weeks from the first fall frost, be vigilant!' }
  }

  return null
}
